import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import {
  FaChartPie,
  FaRegChartBar,
  FaSteam,
  FaChartLine,
  FaFileAlt,
  FaCog,
  FaSignOutAlt
} from 'react-icons/fa';
import authService from '../services/authService';

// Wordmark : 3 barres ascendantes (émeraude → or), glyphe simple sans dépendance externe.
function Logo() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2" y="13" width="4" height="9" rx="1" fill="var(--color-accent)" />
      <rect x="10" y="8" width="4" height="14" rx="1" fill="var(--color-accent)" />
      <rect x="18" y="2" width="4" height="20" rx="1" fill="var(--color-gold)" />
    </svg>
  );
}

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    authService.logout();
    navigate('/login', { replace: true });
  };

  const menuItems = [
    { path: '/', label: 'Tableau de bord', icon: <FaChartPie size={16} /> },
    { path: '/bank-statements/analyse', label: 'Dépenses', icon: <FaChartLine size={16} /> },
    { path: '/investments/overview', label: 'Investissements', icon: <FaRegChartBar size={16} /> },
    { path: '/csgo/overview', label: 'Espace CS:GO', icon: <FaSteam size={16} /> },
    { path: '/documents/tous', label: 'Documents', icon: <FaFileAlt size={16} /> },
    { path: '/settings', label: 'Paramètres', icon: <FaCog size={16} /> }
  ];

  return (
    <div
      className="d-flex flex-column vh-100 text-white position-fixed shadow-lg"
      style={{
        width: '250px',
        top: 0,
        left: 0,
        zIndex: 1100,
        backgroundColor: 'var(--color-surface-dark)'
      }}
    >
      <div className="p-4 mb-2">
        <div className="d-flex align-items-center gap-3">
          <div
            className="rounded-3 p-2 shadow-sm"
            style={{
              width: '40px',
              height: '40px',
              display: 'grid',
              placeItems: 'center',
              backgroundColor: 'var(--color-surface-dark-elevated)'
            }}
          >
            <Logo />
          </div>
          <div>
            <h4
              className="mb-0 fw-bold tracking-tight text-white"
              style={{ fontSize: '1.1rem', fontFamily: 'var(--font-display)' }}
            >
              BecomeRich
            </h4>
            <div
              className="fw-bold tracking-widest"
              style={{ fontSize: '0.6rem', color: 'var(--color-gold)' }}
            >
              ECOSYSTEM
            </div>
          </div>
        </div>
      </div>

      <Nav className="flex-column flex-grow-1 px-3">
        {menuItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith('/' + item.path.split('/')[1]));
          return (
            <Nav.Item key={item.path} className="mb-1">
              <Nav.Link
                as={Link}
                to={item.path}
                className={`d-flex align-items-center rounded-3 py-2 px-3 text-decoration-none transition-all ${isActive ? 'bg-primary shadow-sm fw-bold' : 'opacity-75'}`}
                style={{
                  fontSize: '0.9rem',
                  color: isActive ? '#fff' : '#94a3b8',
                  backgroundColor: isActive ? 'var(--color-accent)' : 'transparent'
                }}
              >
                <span className={`me-3 d-flex ${isActive ? 'text-white' : 'text-secondary'}`}>
                  {item.icon}
                </span>
                <span>{item.label}</span>
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>

      <div className="p-3">
        <Button
          variant="link"
          className="w-100 text-decoration-none d-flex align-items-center justify-content-center py-2 rounded-3 fw-bold"
          style={{ fontSize: '0.7rem', color: '#64748b' }}
          onClick={handleLogout}
        >
          <FaSignOutAlt className="me-2" />
          DÉCONNEXION
        </Button>
      </div>
    </div>
  );
}

export default Sidebar;
